// HomeController
app.controller('HomeController', ['$scope', '$http', 'WdHttpService', '$window', 'config', 'sessionService', 
    function($scope, $http, WdHttpService, $window, config, sessionService) {

        $scope.numberOfFunds = 6;
        $scope.numberOfSteps = 5;
        $scope.init = async function() {
            await $scope.fetchAdviserSiteDetails();
            $scope.showPageLoader("Loading WealthDesk...");
            $scope.brokerBoxHomeCssChanges = 'brokerBoxHomeCssChanges' in config.ADVISERSMETADATA[$scope.distributorUsername] ? config.ADVISERSMETADATA[$scope.distributorUsername]['brokerBoxHomeCssChanges'] : undefined;
            $scope.windowWidth = $window.innerWidth;
            $scope.accordianFlags = [true, false, false, false, false];
            $scope.corouselFlags = [true, false, false, false, false];
            $scope.faqColumn1List = [];
            $scope.faqColumn2List = [];
            $scope.faqColumn3List = [];
            $scope.showFAQCategory = true;
            $scope.showFaqDetails = false;
            $scope.redirectValue = undefined;
            $scope.intiateBrokersList();
            $scope.items2 = [1, 2, 3, 4, 5, 6];

            $scope.backToFaq = function() {
                $scope.showFAQCategory = true;
                $scope.showFaqDetails = false;
            }

            $scope.getFaqs();

            var qData = {
                size: $scope.numberOfFunds,
                sort: 'return:desc',
                f: "web_admin:" + $scope.webadminName
            }

            await WdHttpService._get_funds(qData)
            .then(response => {
                $scope.topFunds = response.data.Items;
                $scope.showtopFunds = true;
            }).catch(error => {
                $scope.showtopFunds = false;
                console.log(error);
            });
            $scope.hidePageLoader();
        }

        $scope.addItem = function(arr, $event) {
            $event.preventDefault();
            arr.push(arr[arr.length - 1] + 1);
            var firstOwl = $("#first").data('owlCarousel');
            firstOwl.addItem("<p>" + arr[arr.length - 1] + "</p>");
        }

        $scope.getFaqs = function() {
            $http({
                method: 'GET',
                url: $scope.faqUrl,
                headers: { 'Content-Type': 'application/json' }
            }).then(function(response) {
                //gettingStarted
                var gettingStarted = response.data.gettingStarted;
                angular.forEach(gettingStarted, function(value, key) {
                    angular.forEach(value, function(Fqvalue, Fqkey) {
                        var getStartKey = Fqkey;
                        $scope.faqColumn1List.push({
                            "question": getStartKey,
                            "answer": Fqvalue
                        });
                    });
                });
                //understandingWealthbaksets
                var understandingWealthbaksets = response.data.understandingWealthbaksets;
                angular.forEach(understandingWealthbaksets, function(value, key) {
                    angular.forEach(value, function(Fqsvalue, Fqskey) {
                        var getStartKeya = Fqskey;
                        $scope.faqColumn2List.push({
                            "question": getStartKeya,
                            "answer": Fqsvalue
                        });
                    });
                });
                //investingMadeSimple
                var investingMadeSimple = response.data.investingMadeSimple;
                angular.forEach(investingMadeSimple, function(value, key) {
                    angular.forEach(value, function(Fqivalue, Fqikey) {
                        var getStartKeys = Fqikey;
                        $scope.faqColumn3List.push({
                            "question": getStartKeys,
                            "answer": Fqivalue
                        });
                    });
                });
            }, function(error) {
                $scope.error = error;
            });
        }

        $scope.analysePortfolio = async function() {
            if (sessionService.isLoggedIn()) {
                $scope.showPageLoader();
                if (!sessionService.isQcLoggedIn()) {
                    await WdHttpService._qc_login().then(response => {
                        $scope.$parent.isQcLoggedIn = true;
                    })
                }
                window.location = config.QC_ANALYZER_URL + "/upload-data?&qcAuth=" + btoa(sessionService.get("qcLogin").idToken) + "&wdAuth=" + btoa(sessionService.get("id")) + "&expiresIn=" + btoa(sessionService.get("qcExpiresIn"));
            } else {
                window.location = "/login?action=holdingsAnalyse";
            }
        }
    }
]).directive("owlCarousel", function() {
    return {
        restrict: 'E',
        transclude: false,
        link: function(scope) {
            scope.initCarousel = function(element) {
                // provide any default options you want
                var defaultOptions = {};
                var customOptions = scope.$eval($(element).attr('data-options'));
                // combine the two options objects
                for (var key in customOptions) {
                    defaultOptions[key] = customOptions[key];
                }
                // init carousel
                var curOwl = $(element).data('owlCarousel');
                if (!angular.isDefined(curOwl)) {
                    $(element).owlCarousel(defaultOptions);
                }
                scope.cnt++;
            };
        }
    };
})
.directive('owlCarouselItem', [function() {
    return {
        restrict: 'A',
        transclude: false,
        link: function(scope, element) {
            // wait for the last item in the ng-repeat then call init
            if (scope.$last) {
                scope.initCarousel(element.parent());
            }
        }
    };
}]).service('anchorSmoothScroll', function() {

    this.scrollTo = function(eID) {

        // This scrolling function 
        // is from http://www.itnewb.com/tutorial/Creating-the-Smooth-Scroll-Effect-with-JavaScript

        var startY = currentYPosition();
        var stopY = elmYPosition(eID);
        stopY = stopY - 120;
        var distance = stopY > startY ? stopY - startY : startY - stopY;
        if (distance < 100) {
            scrollTo(0, stopY);
            return;
        }
        var speed = Math.round(distance / 10);
        if (speed >= 20) speed = 20;
        speed = 40;
        var step = Math.round(distance / 25);
        var leapY = stopY > startY ? startY + step : startY - step;

        var timer = 0;
        if (stopY > startY) {
            for (var i = startY; i < stopY; i += step) {
                setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
                leapY += step;
                if (leapY > stopY) leapY = stopY;
                timer++;
            }
            return;
        }
        for (var i = startY; i > stopY; i -= step) {
            setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
            leapY -= step;
            if (leapY < stopY) leapY = stopY;
            timer++;
        }

        function currentYPosition() {
            // Firefox, Chrome, Opera, Safari
            if (self.pageYOffset) return self.pageYOffset;
            // Internet Explorer 6 - standards mode
            if (document.documentElement && document.documentElement.scrollTop)
                return document.documentElement.scrollTop;
            // Internet Explorer 6, 7 and 8
            if (document.body.scrollTop) return document.body.scrollTop;
            return 0;
        }

        function elmYPosition(eID) {
            var elm = document.getElementById(eID);
            var y = elm.offsetTop;
            var node = elm;
            while (node.offsetParent && node.offsetParent != document.body) {
                node = node.offsetParent;
                y += node.offsetTop;
            }
            return y;
        }

    };

});